import { ListenerListDef } from "../base/ListenerListDef";

export class PrintableListenerDef {
    public static get(): ListenerListDef {
        return { listName: "_printableListeners" };
    }
}
